<template>
  <router-view v-if="!loading" />
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue';
import { loadPrimeVueLocale } from '@/plugins/i18n';
import { isInOffice } from '@/utils/isInOffice';
import { useRootStore } from '@/store/root';
import { useAuthStore } from '@/store/auth';
import router from '@/router';

const loading = ref(true);

const authStore = useAuthStore();
const rootStore = useRootStore();

router.beforeEach(async (to, from, next) => {
  if (!rootStore.getIsInitialized) {
    authStore.checkLogin();
    await rootStore.init(null);
    loading.value = false;
  }

  next();
});

function handleWindowResize() {
  rootStore.updateWindowWidth(window.innerWidth);
  document.documentElement.style.setProperty(
    '--vh',
    `${window.innerHeight * 0.01}px`,
  );
}

onMounted(async () => {
  window.addEventListener('resize', handleWindowResize);
  await loadPrimeVueLocale();
  rootStore.updateWindowWidth(window.innerWidth);
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  if (isInOffice()) {
    document.documentElement.style.setProperty('--isOffice', 'true');
    document.querySelector('#app').classList.add('isOffice');
  }
});

onUnmounted(() => {
  window.removeEventListener('resize', handleWindowResize);
});
</script>
